import { DeleteOutlined } from '@ant-design/icons'
import { Button, Modal } from 'antd'
import { useTranslation } from 'react-i18next'

import { PureTable } from '../../../../../common/ui/pure-table/pure-table'
import { useGetInvitedUsers } from '../../../../../entities/user/hooks/user.hooks'

type InvitedUsersTableProps = {}

export const InvitedUsersTable = ({}: InvitedUsersTableProps) => {
  const { t } = useTranslation()
  const { data: invitedUsers } = useGetInvitedUsers()

  const columns = [
    {
      dataIndex: 'userInfo',
      key: 'userInfo',
      title: t('common.email'),
      headerName: 'userInfo',
      render: (_: any, record: any) => record.email,
    },
    {
      dataIndex: 'projects',
      key: 'projects',
      title: t('usersPage.projects'),
      render: (_: any, record: any) => record.projects.length,
    },
    {
      dataIndex: 'roles',
      key: 'user-roles',
      title: t('usersPage.roles'),
      render: (_: any, record: any) => record.roles.length,
    },
    {
      dataIndex: 'invitationAccepted',
      key: 'accepted',
      title: t('usersPage.invitationAccepted'),
      render: (_: any, record: any) => (record.accepted ? t('common.yes') : t('common.no')),
    },
    {
      key: 'actions',
      title: t('common.actions'),
      width: 100,
      render: (_: unknown, record: { id: number; name: string }) => (
        <Button
          color="danger"
          onClick={() => {
            Modal.confirm({
              title: t('objectsPage.deleteConfirmTitle'),
              content: `${record.name} ${t('objectsPage.deleteDescription')}`,
              onOk: () => console.log('delete invitation'),
            })
          }}
          variant="text"
        >
          <DeleteOutlined />
        </Button>
      ),
    },
  ]

  return (
    <PureTable
      columns={columns}
      dataSource={invitedUsers ?? []}
      rowKey="id"
      searchFields={['email']}
      searchPlaceholder={t('usersPage.searchPlaceholder')}
      searchEnabled
    />
  )
}
